/* ───────────────────────────────────────────────────────────────────────────
   ANCHOR THE FILTER PANEL TO ITS PILL.

   The theme's filter panels are a phone control: position:fixed to the bottom
   of the viewport, full width, sliding up as a sheet. That is right on a
   phone and arbitrary on a desktop, where the panel has to read as belonging
   to the word that opened it.

   The panels are rendered in one block at the end of the section, not inside
   the bar, so no amount of CSS can tie one to its pill. This measures the
   pill and writes two custom properties the stylesheet positions against.
   That is all it does: the theme still owns opening, closing, the scroll
   lock, the form and the apply.

   TIMING. Our listener and the theme's both fire on the same click. The
   measurement is deferred one frame so it runs AFTER the theme has added
   .active and locked body scroll, which is what changes the layout, and
   still before the first paint, so nothing is ever seen unpositioned.
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  var DESKTOP = '(min-width: 60em)';
  var EDGE = 20;
  var last = null;

  function esc(v) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(v);
    return v.replace(/["\\]/g, '\\$&');
  }

  function place(pill) {
    if (!pill) return;
    var handle = pill.getAttribute('data-mobile-filter');
    if (!handle) return;

    var modal = document.querySelector('[data-mobile-modal="' + esc(handle) + '"]');
    if (!modal) return;

    var r = pill.getBoundingClientRect();
    var w = modal.offsetWidth || 300;

    /* Panels near the right edge open leftwards off their pill rather than
       hanging past the window. The sort pill is the one this is for: it sits
       at the far right of the bar by design. */
    var left = r.left;
    if (left + w > window.innerWidth - EDGE) left = r.right - w;
    if (left < EDGE) left = EDGE;

    modal.style.setProperty('--bf-left', Math.round(left) + 'px');
    modal.style.setProperty('--bf-top', Math.round(r.bottom + 10) + 'px');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var pill = e.target.closest('[data-mobile-filter]');
    if (!pill) return;
    if (!window.matchMedia(DESKTOP).matches) return;
    last = pill;
    window.requestAnimationFrame(function () {
      place(pill);
    });
  });

  /* Body scroll is locked while a panel is open, so the pill cannot scroll
     out from under it. A resize still can. */
  window.addEventListener('resize', function () {
    if (!last) return;
    if (!window.matchMedia(DESKTOP).matches) return;
    place(last);
  });
})();
